import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT } from "../interfaces";
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";

export default function zoom_pan_pinch(): any[] {
    return [
        {
          "id": getID( LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH ),
          "type": LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "vertical_align": "center",
          "maxScale": 3,
          "minScale": 0.5,
          "position": { "width": 600, "height": 530 },
          "section": {
            "id": getID( LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH ),
            "data": [
              {
                "width": 600,
                "height": 530,
                "src": "/assets/img/landing/Screenshot_1.jpg",
                "hover_size": 1.1,
                "type": LANDING_TYPE_CONTENT.IMAGE
              }
            ]
          },
          "defaultTitle": "Приблизить-отдалить"
        }
    ]
}